module.exports = "<div id=\"loader\" [hidden]=\"status != 'loading'\">\n    <itpx-spinner></itpx-spinner>\n</div>\n\n<div class=\"scorm-cloud-content\" *ngIf=\"iframeUrl && status != 'loading'\">\n  <div class=\"evaluation\">\n    <h2>Evaluation Copy - not intended for commercial use</h2>\n  </div>\n  <iframe [src]=\"iframeUrl | safeUrl\"></iframe>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/evaluation/content/scormcloud/scorm-cloud.component.html
// module id = 883
// module chunks = 0